import gql from "graphql-tag";

export default gql`
  mutation updateDocumentType($data: UpdateDocumentType!) {
    updateDocumentType(data: $data)
  }
`;
